import { render, staticRenderFns } from "./DispatchVehiclesTable.vue?vue&type=template&id=4468e626&"
import script from "./DispatchVehiclesTable.vue?vue&type=script&lang=js&"
export * from "./DispatchVehiclesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4468e626')) {
      api.createRecord('4468e626', component.options)
    } else {
      api.reload('4468e626', component.options)
    }
    module.hot.accept("./DispatchVehiclesTable.vue?vue&type=template&id=4468e626&", function () {
      api.rerender('4468e626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dispatching/DispatchVehiclesTable.vue"
export default component.exports